import angular from 'angular';

const componentOptions = {
    bindings: {
        range: '='
    },
    controllerAs: 'bidsTooltipCtrl',
    templateUrl: [
        '$rootScope',
        function ($rootScope) {
            return $rootScope.routes.templates + 'ib-bids-tooltip-view.html';
        }
    ]
};

const componentInfo = {
    module: 'ib-upgrading-bids-tooltip-module',
    selector: 'ibBidsTooltip',
    inject: ['$scope', '$rootScope'],
    required: ['']
};

export class ibBidsTooltip implements ng.IController {
    range: string;
}

try {
    const mod = angular.module(componentInfo.module);
    ibBidsTooltip.$inject = componentInfo.inject;
    mod.component(componentInfo.selector, angular.extend(componentOptions, { controller: ibBidsTooltip }));
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibBidsTooltip.$inject = componentInfo.inject;
    mod.component(componentInfo.selector, angular.extend(componentOptions, { controller: ibBidsTooltip }));
}
